import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { ThemeProvider } from "./context/ThemeContext";
import { ThemeProvider as AppThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { ProfileProvider } from "./contexts/ProfileContext";
import { UserInfoProvider } from "./contexts/UserInfoContext";
import i18n from "./i18n";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <AppThemeProvider>
          <AuthProvider>
            <ProfileProvider>
              <UserInfoProvider>
                <BrowserRouter basename={__BASE_PATH__}>
                  <AppRoutes />
                </BrowserRouter>
              </UserInfoProvider>
            </ProfileProvider>
          </AuthProvider>
        </AppThemeProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;